import { Component, Inject, OnInit } from "@angular/core";
import { Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  DialogActionType,
  EdtellDialogComponent,
  EdtellDialogData,
  EdtellFormControl,
  EdtellFormGroup,
  NotificationService,
  SrsFormFieldConfig,
  SrsFormState,
  SrsRadioButtonComponent,
  SrsRadioGroupConfig,
} from "@edtell-common";
import { Observable } from "rxjs";
import { EdtellFrontFacingDialogConfig } from "src/app/modules/edtell-common/edtell-containers/interface/edtell-front-facing-dialog-config.interface";

@Component({
  selector: "app-ncaa-dialog",
  templateUrl: "./ncaa-dialog.component.html",
  styleUrls: ["./ncaa-dialog.component.scss"],
})
export class NcaaDialogComponent
  extends EdtellDialogComponent
  implements OnInit
{
  dialogData: EdtellDialogData;
  formGroup: EdtellFormGroup;
  objectTitle: string;

  radioConfig: SrsRadioGroupConfig;
  formFieldConfig: SrsFormFieldConfig;

  frontFacingDialogConfig: EdtellFrontFacingDialogConfig = {
    header: "NCAA Student Athlete Check",
    edtellDialogRef: this,
    submitButtonConfig: {
      text: "Continue to Review Your Courses",
      submitCallback: () => {
        this.dialogData.objectData = this.formGroup.value;
        this.dialogRef.close(this.dialogData);
      },
      disabled: () => {
        if (this.formGroup.get("ncaa").value == null) {
          return true;
        }
        if (!this.formGroup.get("ncaa").value) {
          return false;
        }
        if (this.formGroup.get("ncaaId").value == null) {
          return true;
        }
        return this.formGroup.get("ncaaId").value.length < 10;
      },
    },
    hideCloseDialogButton: false,
  };
  showNcaaId = false;

  loaded = false;

  constructor(
    public dialogRef: MatDialogRef<NcaaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EdtellDialogData,
    public notificationService: NotificationService,
  ) {
    super(data.action as DialogActionType, notificationService);
    this.dialogData = data;
  }

  dialogOnInit() {
    this.initTemplateConfig();
    this.showNcaaId = this.dialogData.objectData.ncaa ?? false;
    this.loaded = true;
  }

  initForm() {
    this.formGroup = new EdtellFormGroup(SrsFormState.WRITE, {
      ncaa: new EdtellFormControl(this.dialogData.objectData.ncaa),
      ncaaId: new EdtellFormControl(
        this.dialogData.objectData.ncaaId,
        Validators.required,
      ),
    });
  }

  initTemplateConfig() {
    this.radioConfig = {
      key: "ncaa",
      options: [
        {
          text: "Yes",
          value: true,
        },
        {
          text: "No",
          value: false,
        },
      ],
      onChange: (control) => {
        this.showNcaaId = control.value;
      },
      size: 12,
      title: null,
      group: this.formGroup,
    };

    this.formFieldConfig = {
      key: "ncaaId",
      size: 12,
      title: "NCAA ID:",
      maxCharacters: 10,
      settings: {
        numberInput: true,
        hideMaxCharacterHint: true,
      },
      group: this.formGroup,
    };
  }

  create(reqBody: any): Observable<any> {
    return null;
  }
  update(reqBody: any): Observable<any> {
    return null;
  }
  delete(id: number): Observable<any> {
    return null;
  }
}
